import React from 'react'
import { ButtonRound, Container, Content, Line } from './styles'

import {
  FaBarsStaggered,
  FaChevronLeft,
  FaChevronRight,
  FaGear,
  FaHouse,
} from 'react-icons/fa6'
import { useLocation, useNavigate } from 'react-router-dom'
import { Row } from '../commons'
import { useDirectory } from '../../store/directory'
import { ButtonIcon } from '../Table/Pagination/styles'

export interface HeaderProps {
  title?: string
  handleModal: () => void
}

const getModuloAtual = (pathname: string): string => {
  if (pathname.startsWith('/conferencia')) return 'Conferência'
  if (pathname.startsWith('/documents') || pathname.startsWith('/document/')) return 'Documentos'
  if (pathname.startsWith('/documentTypes')) return 'Tipos de Documentos'
  if (pathname.startsWith('/api-integration')) return 'Integração API'
  if (pathname.startsWith('/reports')) return 'Relatórios'
  if (pathname.startsWith('/users')) return 'Usuários'
  if (pathname.startsWith('/groups')) return 'Grupos'
  if (pathname.startsWith('/logs')) return 'Logs'
  if (pathname.startsWith('/config')) return 'Configurações'
  return 'Início'
}

const Header: React.FunctionComponent<HeaderProps> = ({ handleModal }) => {
  const nav = useNavigate()
  const location = useLocation()
  const { directory, history, setDirectory, setHistory } = useDirectory((state) => state)

  const nomeModulo = getModuloAtual(location.pathname)

  const goBack = () => {
    if (location.pathname !== '/documents') {
      nav(-1)
    } else {
      if (directory.length > 1) {
        setHistory(directory)

        let dir = [...directory]
        dir.pop()

        setDirectory(dir)
      }
    }
  }
  const goFoward = () => {
    if (location.pathname !== '/documents') {
      nav(1)
    } else {
      let historyAux = history

      setDirectory(historyAux)
      setHistory(directory)
    }
  }

  return (
    <Container>
      <Content>
        <Row style={{ gap: 10, height: '100%', alignItems: 'center' }}>
          <ButtonRound onClick={goBack}>
            <FaChevronLeft color={'white'} size={15} />
          </ButtonRound>
          <ButtonRound onClick={goFoward}>
            <FaChevronRight color={'white'} size={15} />
          </ButtonRound>
          <Line />

          <ButtonIcon onClick={handleModal} title="Abrir Menu Lateral">
            <FaBarsStaggered size={25} />
          </ButtonIcon>

          {/* Botão dedicado para o Início */}
          <button
            type="button"
            onClick={() => nav('/documents')}
            title="Retornar para a Tela Principal (Documentos)"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              padding: '6px 12px',
              borderRadius: 6,
              border: '1px solid #cbd5e1',
              background: '#ffffff',
              color: '#0f172a',
              fontSize: 12,
              fontWeight: 600,
              cursor: 'pointer',
              boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
              transition: 'all 0.15s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#f8fafc';
              e.currentTarget.style.borderColor = '#94a3b8';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#ffffff';
              e.currentTarget.style.borderColor = '#cbd5e1';
            }}
          >
            <FaHouse size={13} color="#2563eb" />
            <span>Início</span>
          </button>

          {/* Card com o nome do Módulo em Uso */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 7,
              padding: '5px 12px',
              borderRadius: 6,
              background: 'rgba(37, 99, 235, 0.08)',
              border: '1px solid rgba(37, 99, 235, 0.25)',
              color: '#1d4ed8',
              fontSize: 12,
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.04em',
            }}
          >
            <span
              style={{
                width: 6,
                height: 6,
                borderRadius: '50%',
                background: '#2563eb',
                display: 'inline-block',
              }}
            />
            <span>{nomeModulo}</span>
          </div>

          <Line />
        </Row>
        <Row style={{ gap: 10, height: '100%' }}>
          <ButtonIcon onClick={() => nav('/config')}>
            <FaGear size={25} />
          </ButtonIcon>
        </Row>
      </Content>
    </Container>
  )
}

export default Header
